/**
 * LoadingAnimation.jsx
 * This component is used to display a loading animation.
 * It is used when data is being fetched from the server.
 *
 **/

import React from "react";
import { Spinner } from "react-bootstrap";
import "./LoadingAnimation.scss";

const LoadingAnimation = () => {
  return (
    <div className="loader">
      <Spinner animation="grow" />
    </div>
  );
};

export default LoadingAnimation;
